export default {
  btnAdd:'اضافه کردن دسته بندی',
  btnEdit:'ویرایش',
  btnDelete:'حذف',
  success : 'موفق',
  deleted : 'حذف شد',
  error : 'خطا در حذف'





}
